module.exports = __webpack_public_path__ + "img/智能充电桩1.fe9dc530.png";